export const FONTSARRAY = [
  'Archivo',
  'Assistant',
  'Fira Sans',
  'IBM Plex Sans',
  'Lato',
  'Libre Franklin',
  'Noto Sans',
  'Open Sans',
  'Roboto',
  'Source Sans Pro',
  'Titillium Web',
  'Work Sans',
];

export const COLORARRAY = [
  '#27AB83',
  '#5045E6',
  '#EC4899',
  '#0C9488',
  '#F56B3F',
  '#8169FE',
  '#F7C340',
  '#6937CE',
  '#0D6B59',
  '#5355BF',
  '#7BBEE0',
  '#62DECC',
  '#6888F5',
  '#BAC0CB',
];

export const BGCOLORARRAY = ['#FFFFFF', '#F5F7FB', '#22252D'];

export const CARDBGCOLORARRAY = ['#F5F7FB', '#FFFFFF', '#07090A'];

export const DROPDOWNBGCOLORARRAY = ['#CCCCCC', '#CCCCCC', '#333'];

export const DATA = [
  {
    month: 'Jan',
    value: 3299,
    value1: 7880,
    value2: 9152,
  },
  {
    month: 'Feb',
    value: 1782,
    value1: 4414,
    value2: 6278,
  },
  {
    month: 'Mar',
    value: 3284,
    value1: 6234,
    value2: 2805,
  },
  {
    month: 'Apr',
    value: 8334,
    value1: 3033,
    value2: 8235,
  },
  {
    month: 'May',
    value: 3356,
    value1: 4979,
    value2: 2001,
  },
  {
    month: 'Jun',
    value: 4630,
    value1: 6737,
    value2: 4427,
  },
  {
    month: 'Jul',
    value: 6526,
    value1: 9906,
    value2: 2650,
  },
  {
    month: 'Aug',
    value: 1534,
    value1: 4536,
    value2: 5171,
  },
  {
    month: 'Sep',
    value: 7136,
    value1: 1514,
    value2: 6421,
  },
  {
    month: 'Oct',
    value: 6061,
    value1: 6221,
    value2: 8705,
  },
  {
    month: 'Nov',
    value: 8407,
    value1: 4374,
    value2: 3015,
  },
  {
    month: 'Dec',
    value: 4695,
    value1: 2628,
    value2: 8008,
  },
];

export const WINDOWWIDTH = 1280;

export const GUTTER = 20;

export const COLUMNWIDTH = [
  {
    oneColumn: 295,
    twoColumn: 610,
    threeColumn: 925,
    fullWidth: 1240,
  },
  {
    oneColumn: 270,
    twoColumn: 560,
    threeColumn: 850,
    fullWidth: 1140,
  },
  {
    oneColumn: 255,
    twoColumn: 530,
    threeColumn: 805,
    fullWidth: 1080,
  },
];

export const HEIGHT = 260;

export const TICKTITLEHEIGHT = 30;

export const TICKVALUEWIDTH = 30;

export const MARGINTOP = 20;

export const MARGINSIDE = 20;

export const BARSMARGINSIDE = 45;

export const LINEARSCALEOFFSET = 15;
